<template>
  <div class="card card-default">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label>Supplier Name</label>
          <input
            v-model="supplier.name"
            type="text"
            class="form-control"
          />
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-6">
          <label>Registered Company Name</label>
          <input
            v-model="supplier.registeredCompanyName"
            type="text"
            class="form-control"
          />
        </div>
        <div class="form-group col-md-6">
          <label>Xero Accounting ID</label>
          <input
            v-model="supplier.accountingId"
            type="text"
            class="form-control"
          />
        </div>
      </div>

      <div class="save-button-wrapper">
        <button
          class="btn btn-info m-0"
          :disabled="isSaving"
          @click="updateSupplier()"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      supplierNumber: 0,
      supplier: {},
      isSaving: false,
    };
  },
  created() {
    this.$root.$emit("SET_PAGE_TITLE", this.$route.meta.title);
  },
  mounted: function() {
    this.supplierNumber = this.$route.params.supplierNumber;
    this.getSupplier();
  },
  methods: {
    getSupplier() {
      this.$http.get(this.$config.aimsAPIv3 + "suppliers/" + this.supplierNumber)
        .then((response) => {
          this.supplier = response.data || {};
          this.$root.$emit(
            "SET_PAGE_TITLE",
            this.$route.meta.title + " - " + this.supplier.name
          );
        }, (error) => {
          console.error(error);
          this.showError("Error Fetching Supplier", error);
        });
    },
    updateSupplier() {
      this.isSaving = true;

      this.$http.put(this.$config.aimsAPIv3 + "suppliers/update", this.supplier)
        .then(() => {
          this.showSuccess("Supplier updated");
          this.getSupplier();
        }, (error) => {
          console.error(error);
          this.showError("Error Updating Supplier", error);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
  },
};
</script>
